import { useFetch } from "../../../utils/hooks/useFetch";
import ArrowRight from "../../../assets/icons/arrow_right.png";
import { useRef, useEffect } from "react";
import "./_shortssection.scss";
import Pause from "../../Player/Pause";
import Play from "../../Player/Play";

const ShortCard = ({ short, activeTrackId, setActiveTrackId }) => {
  const audioRef = useRef();
  const isPlaying = activeTrackId === `short_${short.id}`;

  useEffect(() => {
    if (!isPlaying && audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, [isPlaying]);

  const togglePlayPause = () => {
    if (!short.music) return;

    if (isPlaying) {
      audioRef.current?.pause();
      setActiveTrackId(null);
    } else {
      audioRef.current?.play();
      setActiveTrackId(`short_${short.id}`);
    }
  };

  return (
    <div className="short-card">
      <div className="short-img-container">
        <img src={short.cover} alt={short.alt} />

        {short.music && (
          <>
            <audio ref={audioRef} src={short.music} />
            <button
              className={`short-play-btn ${isPlaying ? "playing" : ""}`}
              onClick={togglePlayPause}
            >
              {isPlaying ? <Pause /> : <Play />}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export const ShortsSection = ({ activeTrackId, setActiveTrackId }) => {
  const [shorts] = useFetch("JSON/shorts.json");
  const shortsToDisplay = shorts.slice(0, 3);

  return (
    <section>
      <a href="/shorts" className="section-title-link">
        <h2>Court-métrages</h2>
        <img src={ArrowRight} alt="arrow right" />
      </a>
      <h3>Sélection de fictions</h3>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem", justifyContent: "center" }}>
        {shortsToDisplay.map((obj, index) => (
          <ShortCard
            key={index}
            short={obj}
            activeTrackId={activeTrackId}
            setActiveTrackId={setActiveTrackId}
          />
        ))}
      </div>
    </section>
  );
}